module.exports = __webpack_public_path__ + "static/media/tone1_ok.727036af.svg";